<style lang="scss">
  #app{
    height:100%;
    overflow-y: scroll;
    #topMenu{
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
      transition:all 0.5s;
    }
    #content{
      .mainPage{
        min-height: 600px;
      }
    }
    #AutomaticCustomerServiceSNZJ{
      position:fixed;
      bottom:15%;
      right:10px;
      cursor: pointer;
      img{
        border-style: none;
        box-shadow: 0 0 5px;
        width:67px;
        height:67px;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
    }
  }
  #app.spo{
    overflow-y: unset;
  }
</style>
<template>
  <div id="app" ref="appHome" :class="!juage?'spo':''">
    <topMenu v-if="update&&juage"></topMenu>
  	<div id="content">
    	<router-view class="mainPage"></router-view>
      <bottomFooter v-if="juage"></bottomFooter>
  	</div>
  	<!-- <service></service> -->
    <div id="AutomaticCustomerServiceSNZJ" v-if="juage" >
      <img src="./assets/img/zxkf.png"/>
    </div>
  </div>
</template>

<script>
import topMenu from '@/components/base/menu.vue';
import bottomFooter from '@/components/base/footer.vue';
import service from '@/components/base/service.vue';
export default {
  data() {
    return {
      update:false,
      juage:true
    }
  },
	components:{
		topMenu,bottomFooter,service
	},
  created() {
    if(this.$route.path=='/DeliveryInfo.html'||this.$route.path=='/InternalUseTools.html'){
      this.juage=false
    }else{
      this.juage=true
    }
    this.$nextTick(() => {
      this.update = true;
      this.$refs.appHome.addEventListener('scroll',() => {
        if (this.$refs.appHome.scrollTop) {
          document.getElementById('topMenu').style.backgroundColor = 'rgba(0,71,103,1)'
        }else{
          document.getElementById('topMenu').style.backgroundColor = 'rgba(0,71,103,0)'
        }
        
      })
      window.snapSaveState = () => {
        document.querySelector("#app").setAttribute("data-server-rendered", "true");
      };
    })
  },
  watch:{
    '$route': function(to,from){
      if (document.getElementById('app')) {
        document.getElementById('app').scrollTop = 0;
        this.$nextTick(() => {
          this.update = true
        })
      }
    }
  }
}
</script>
